import { render, staticRenderFns } from "./VGroupDealState.vue?vue&type=template&id=0aa71b6c"
import script from "./VGroupDealState.vue?vue&type=script&lang=js"
export * from "./VGroupDealState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports